import React, {useMemo} from 'react';
import InfoTooltip from "../../../components/InfoTooltip";
import {useAuth} from "../../../providers/AuthProvider";
import {useProject} from "../../../providers/ClientProjectProvider";
import {usePosition} from "../../../providers/ProjectPositionProvider";

const PositionTimeline = (props) => {
    const {auth} = useAuth();
    const {project, isLoading} = useProject();

    const isFixedFee = project.isFixedFee();
    const {
        position,
        isProjectUpdating: isDisabled
    } = usePosition();

    let durations = TB.filter((project?.positionDurations() || [])[position.id], dur => dur?.count > 0);
    const deliverables = useMemo(() => {
        if (position.assigned_candidate && position.assigned_candidate?.job_candidate?.talent_opps?.length) {
            return position.assigned_candidate?.job_candidate?.talent_opps[0].position_deliverables;
        }
        return position.activeDeliverables();
    }, [position, isDisabled]);
    return (
        <React.Fragment>
            {project.isFixedFee() && (
                <div className="flex flex-col gap-3 my-4 items-start">
                    <p className="font-semibold">
                        * Deliverables included in scope
                    </p>
                    <div className="flex flex-row items-start gap-y-5 gap-x-3.5 flex-wrap">
                        {TB.map(deliverables, del => {

                            return (
                                <div key={`pos${position.id}-del-${del.id}`}
                                     className="py-3 px-4 bg-light-gray3 flex flex-row items-center flex-nowrap">
                                    <p className="max-w-[600px] text-xs flex flex-row items-center gap-2" style={{lineHeight: 22}}>
                                        <i className="fas fa-clipboard-check text-[22px]"/>
                                        <span className="line-clamp-1">{del.name}</span>
                                    </p>
                                    <InfoTooltip type="dark" iconColor="black" iconSize={11}>
                                        <p className="p-1 text-white font-semibold text-xxs">
                                            {del.target_delivery_at ?
                                                TB.moment(del.target_delivery_at).format('ll') : (
                                                    <i>Date Not Provided</i>
                                                )
                                            }
                                        </p>
                                    </InfoTooltip>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}
            <div className="gap-[24px] flex flex-col items-stretch">
                <div className="dates">
                    {durations.map((bar, bi) => {
                        let {count, isActive} = bar;
                        if (bi === 1 && isActive) {
                            //
                        }
                        const key = `dTRow-${position.id}-segment-${bi}-disabled-${isDisabled}`;

                        return (
                            <div key={key} style={{flex: count}}
                                 className={TB.mapClass("flex date-bar", {"bg-skyblue": isActive})}>

                                {bar.items?.length && TB.map(bar.items, item => {

                                    let barPos = (item.start / count) * 100;
                                    if (!item.deliverables?.length) {
                                        return null;
                                    }
                                    let firstDel = item.deliverables[0];
                                    return (
                                        <React.Fragment>
                                            <div id={`pos-${position.id}-del-${firstDel.id}`} key={item.id}
                                                 className="absolute top-0 bottom-0 bg-warning rounded-[37px] flex flex-row items-center gap-1 justify-center"
                                                 style={{
                                                     left: `${barPos}%`,
                                                     marginLeft: item.deliverables?.length > 1 ? -15 : -10,
                                                     width: item.deliverables?.length > 1 ? 30 : 20,

                                            }}>
                                                <i className="fas fa-check text-black text-xxs"/>
                                                {item.deliverables?.length > 1 && <span className="text-black font-semibold text-xxs">{item.deliverables?.length}</span>}

                                            </div>
                                            <InfoTooltip target={`pos-${position.id}-del-${firstDel.id}`} placement="top" type="dark">
                                                <div className="flex flex-col gap-2.5 pb-2.5 divide-y divide-white">
                                                    {TB.map(item.deliverables, deliverable => (
                                                        <div key={`pos-${position.id}-delinfo-${deliverable.id}`}
                                                            className="flex flex-col gap-1 items-start">
                                                            <p className="p-0 text-xxs mt-2.5 items-left text-white">
                                                                {TB.moment(deliverable.target_delivery_at).format('ll')}
                                                            </p>
                                                            <p className="p-0 text-xs items-left text-white">
                                                                {deliverable.name}
                                                            </p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </InfoTooltip>
                                        </React.Fragment>
                                    )
                                })}
                                {isActive && (
                                    <div
                                        className={TB.mapClass("date-start-label", {offset: bi > 0 && durations[bi - 1].count > 0})}>
                                        <p className="whitespace-nowrap">
                                            {position.startedAt()?.format('MMM D YYYY')}
                                        </p>
                                        <p className="whitespace-nowrap">
                                            Week {bar.start}
                                        </p>
                                    </div>
                                )}

                                {isActive && (
                                    <div
                                        className={TB.mapClass("date-end-label", {offset: bi < (durations.length - 1) && durations.length > 1})}>
                                        <p className="whitespace-nowrap">
                                            {position.endedAt()?.format('MMM D YYYY')}
                                        </p>
                                        <p className="whitespace-nowrap">
                                            Week {bar.start + count}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )
                    })}
                </div>

                {props.children}
            </div>
        </React.Fragment>
    )
};

export default PositionTimeline;